import React, { useEffect } from "react";
import { Box, Grid, Paper } from "@mui/material";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import TradedAccountsList from "../TradedAccountsList";
import { CircularProgress } from "../../../../components/ui";
import { INewTradedAccount } from "../../../../api/funds/index.types";
import {
  EEvaluationType,
  EInvoiceStatusesLiveFundedTrader,
  EProcessingStatuses,
} from "../../../../constants";
import { fetchTradedAccounts } from "../../utils";
import CreateTradedAccountForm from "../CreateTradedAccountForm";

export interface INewTradedAccountForm
  extends Omit<INewTradedAccount, "processing_status" | "invoice_status" | "accounts_id"> {
  processing_status: EProcessingStatuses | "";
  invoice_status: EInvoiceStatusesLiveFundedTrader | "";
  evaluation_completed_history_id: number | null;
  evaluation_type: EEvaluationType | "";
}

const TradedAccounts = (): React.ReactElement => {
  const dispatch = useDispatch();
  const params: { id: string; funded_trader_id: string } = useParams();
  const fundedTraderId = +params.funded_trader_id;

  const {
    tradedAccounts: { isLoading: isFetchingTradedAccounts },
    fundedAccounts,
    priorAccounts,
  } = useSelector((state) => state.fundedTrader);

  useEffect(() => {
    (async () => {
      await fetchTradedAccounts(dispatch, fundedTraderId);
    })();
  }, [fundedTraderId]);

  return (
    <Paper
      sx={{
        marginTop: "15px",
        marginBottom: "20px",
        padding: "14px",
        backgroundColor: "#f2f2f2",
      }}
    >
      <Box component="b" display="block" m="10px 0">
        Add new account
      </Box>

      <CircularProgress isLoading={isFetchingTradedAccounts} />
      {!isFetchingTradedAccounts && <CreateTradedAccountForm />}

      {!isFetchingTradedAccounts && (
        <Box mt="15px" mb="20px">
          <Grid container spacing={3}>
            <Grid item xs={12}>
              <TradedAccountsList
                fetchTradedAccounts={() => fetchTradedAccounts(dispatch, fundedTraderId)}
                title="Funded accounts"
                listItems={fundedAccounts}
                priorAccounts={priorAccounts}
              />

              <TradedAccountsList
                withCollapse
                fetchTradedAccounts={() => fetchTradedAccounts(dispatch, fundedTraderId)}
                title="Prior accounts"
                listItems={priorAccounts}
                priorAccounts={fundedAccounts}
              />
            </Grid>
          </Grid>
        </Box>
      )}
    </Paper>
  );
};

export default TradedAccounts;
